import { fetchSuggestions } from '../utils/equifax2019';
import { useAddressSuggestions2025Func } from '../utils/equifax2025';
import { AddressTypeahead, ExternalProps } from './AddressTypeahead';

interface Props extends ExternalProps {
  border?: boolean;
}

const AddressTypeaheadEquifax2019 = (props: Props) => (
  <div style={props.border ? { padding: "20px", border: "1px solid #cdf" } : {}}>
    <AddressTypeahead fetchSuggestions={fetchSuggestions} {...props}/>
  </div>
);

const AddressTypeaheadEquifax2025 = (props: Props) => {
  const execute = useAddressSuggestions2025Func();
  return (
    <div style={props.border ? { padding: "20px", border: "1px solid #cdf" } : {}}>
      <AddressTypeahead fetchSuggestions={execute} {...props}/>
    </div>
  );
};


// export const AddressTypeaheadEquifax = AddressTypeaheadEquifax2019;
export const AddressTypeaheadEquifax = AddressTypeaheadEquifax2025;
